import * as csv from 'csvtojson';
import * as React from 'react';
import { IEvent } from 'types/events';
import { Subtract } from 'utility-types';

import { WithEventsCsvLinkQueryProps } from './withEventsCsvLink';
import { WithEventsProps } from './withEventsState';

interface IRequiredProps {
  country: string;
}

type RequiredProps = IRequiredProps & WithEventsCsvLinkQueryProps;

interface IConfig {
  withEventFilters?: boolean;
  withCountryFilter?: boolean;
  default?: 'country' | 'global';
}

export interface IWithEventsCsvProps {
  eventsData: {
    events: IEvent[];
    loading: boolean;
    error: boolean;
    loaded: boolean;
  };
}

let eventsCached: IEvent[] | undefined;

interface IState {
  events: IEvent[];
  loading: boolean;
  error: boolean;
  loaded: boolean;
}

const parseDate = (date: string) => {
  if (typeof date === 'string') {
    const splitDate = date.split('-');
    if (splitDate.length === 3) {
      splitDate.reverse();
      const newDate = splitDate.join('-');
      return new Date(newDate);
    }
  }
  return new Date();
};

const withEventsCsv = (config?: IConfig) => <P extends IWithEventsCsvProps>(
  Component: React.ComponentType<P>
) => {
  type Props = Subtract<P, IWithEventsCsvProps> &
    RequiredProps &
    WithEventsProps;
  return class WithEventsCsv extends React.Component<Props, IState> {
    public state: IState = {
      error: false,
      events: [],
      loaded: false,
      loading: true
    };
    constructor(props: Props) {
      super(props);
      if (eventsCached) {
        this.state = {
          error: false,
          events: eventsCached,
          loaded: true,
          loading: false
        };
      }
    }
    public fetchCsv = async () => {
      if (
        !this.props.loading &&
        this.props.data &&
        this.state.events &&
        !eventsCached
      ) {
        const response = await fetch(this.props.data.fetch.Events);
        const text = await response.text();
        const t = await csv().fromString(text);
        try {
          eventsCached = t.map<IEvent>(event => {
            const endDate = event['End Date'];
            const startDate = event['Start Date'];
            return {
              City: event.Location,
              Country: event.Who,
              EndDate: Math.floor(parseDate(endDate).getTime() / 1000) + '',
              Level: event.Level,
              StartDate: Math.floor(parseDate(startDate).getTime() / 1000) + '',
              Title: event.Subject + ' ' + event.Who,
              Venue: event.Description,
              _meta: {
                id: event.Subject + ' ' + event.Who
              }
            };
          });

          this.setState({ events: eventsCached });
        } catch (e) {
          this.setState({ error: true });
        }

        this.setState({ loaded: true, loading: false });
      }
    };
    public componentDidMount() {
      this.fetchCsv();
    }
    public componentDidUpdate() {
      this.fetchCsv();
    }
    public render() {
      let theEvents = this.state.events;
      if (
        this.props.events.eventsSearchText &&
        this.props.events.eventsSearchText !== 'All'
      ) {
        theEvents = this.state.events.filter(
          e =>
            e.Country.toLowerCase().indexOf(
              this.props.events.eventsSearchText.toLowerCase()
            ) > -1
        );
      }

      return (
        <Component
          eventsData={{ ...this.state, events: theEvents }}
          {...this.props as any}
        />
      );
    }
  };
};

export default withEventsCsv;



// WEBPACK FOOTER //
// ./src/enhancers/withEventsCsv.tsx